



























import { Component, Prop, Vue } from 'vue-property-decorator';
import Focusable from '@/baklava/Focusable';

@Component
export default class IntegerInc extends Vue {
  @Prop() value!: number;

  @Prop() index!: number;

  private edit = false;
  private editValue = '';
  private inputBoxWidth = 0;

  private increment() {
    this.$emit('value-change', this.value + 1, this.index);
  }

  private decrement() {
    this.$emit('value-change', this.value - 1, this.index);
  }

  private updateValue() {
    this.$emit('value-change', parseInt(this.editValue, 10), this.index);
  }

  private focusOut() {
    this.updateValue();
    this.toggle();
  }

  private enter() {
    (this.$refs.box as Focusable).focus();
    this.updateValue();
  }

  private editOn() {
    this.editValue = this.value.toString();
    this.inputBoxWidth = (this.$refs.text as Vue & { clientWidth: number }).clientWidth;
    this.toggle();
    this.$nextTick(() => {
      (this.$refs.input as Focusable).focus();
    });
  }

  private toggle() {
    this.edit = !this.edit;
  }
}
